// This WebAudioEncoderImpl is needed for Safari for now, because Safari doesn't
// yet support the WebCodecs audio API.
import EventEmitter from 'eventemitter3';
import { Settings } from '../../Settings';
import { AudioVolumeCalculator } from '../helpers/AudioVolumeCalculator';
import { PolyfillOpusEncoder } from './PolyfillOpusEncoder';
import { WebAudioRecorder } from './WebAudioRecorder';
const VOLUME_CALCULATION_INTERVAL_FRAMES = Settings.audioVolumeCalculationIntervalFrames;
export class WebAudioEncoderImpl {
    emitter;
    webAudioRecorder;
    polyfillOpusEncoder;
    volumeCalculationCounter = 0;
    constructor() {
        this.emitter = new EventEmitter();
    }
    async start(audioTrack) {
        console.log('WebAudioEncoderImpl::start()', audioTrack);
        this.polyfillOpusEncoder = new PolyfillOpusEncoder();
        this.polyfillOpusEncoder.emitter.on('audioData', (encodedAudioData) => {
            this.emitter.emit('audioData', encodedAudioData);
        });
        this.webAudioRecorder = new WebAudioRecorder();
        await this.polyfillOpusEncoder.init();
        this.webAudioRecorder.on('data', async (timestampMicros, samples) => {
            this.polyfillOpusEncoder?.encode(timestampMicros, samples);
            if (this.volumeCalculationCounter %
                VOLUME_CALCULATION_INTERVAL_FRAMES ===
                0) {
                const volume = AudioVolumeCalculator.calculateVolumeFromFloat32Array(samples);
                this.emitter.emit('audioVolume', volume);
            }
            this.volumeCalculationCounter++;
        });
        await this.webAudioRecorder.start(audioTrack);
    }
    async stop() {
        console.log('WebAudioEncoderImpl stop');
        this.webAudioRecorder?.stop();
        await this.polyfillOpusEncoder?.stop();
    }
}
